import { Component, Input } from "@angular/core";
import { NgClass } from "@angular/common";

@Component({
    selector: "app-form-payment-cc-icons",
    template: `

            <img [ngClass]="{'highlight': creditCardType === 'Discover'}" 
                class="cc-Icon" src="assets/Icons/credit-card-icons/discover_cc_icon.svg" alt="checkmark"/>
            <img [ngClass]="{'highlight': creditCardType === 'American Express'}" 
                class="cc-Icon" src="assets/Icons/credit-card-icons/amex_cc_icon.svg" alt="checkmark"/>
            <img [ngClass]="{'highlight': creditCardType === 'Visa'}" 
                class="cc-Icon" src="assets/Icons/credit-card-icons/visa_cc_icon.svg" alt="checkmark"/>
            <img [ngClass]="{'highlight': creditCardType === 'Mastercard'}" 
                class="cc-Icon" src="assets/Icons/credit-card-icons/mastercard_cc_icon.svg" alt="checkmark"/>
        
    `,
    styleUrls: ["./form-payment-cc-icons.component.scss"],
    standalone: true,
    imports: [NgClass]  

})

export class FormPaymentCcIconsComponent {
    @Input() creditCardType!: string;

    constructor() {}

}